import { fg } from '@atlaskit/platform-feature-flags';
import { type AdfParserConfig } from '@atlassian/adf-parser';

export function getParserConfig(): AdfParserConfig {
	return {
		lenientStringParsing: fg('platform_editor_ai_lenient_string_parsing'),
		autoCloseObjectOnRightBracket: fg('platform_editor_ai_less-aggro-obj-parsing'),
		liftInvalidBlockNodes: fg('platform_editor_ai_parser_lift_nodes'),
		useTypedErrors: fg('platform_editor_ai_structured_parser_errors'),
		filterInvalidMarks: fg('platform_editor_ai_filter_invalid_marks'),
		ignoreUnknownCharacters: fg('platform_editor_ai_adf_parser_ignore_unknown_char'),
		useUnifiedContentParsing: fg('platform_editor_ai_adf_parser_refactor'),
		fuzzyNodeTypeMatching: fg('platform_editor_ai_adf_parser_fuzzy_node_matching'),
	};
}
